import { createSelector } from '@reduxjs/toolkit';

import { configBaseSelector } from './leadAttributesSelector';

export const userMapSelector = createSelector(
  configBaseSelector,
  (configDetails) => configDetails.users,
);
